import React, { useEffect, useCallback, useState } from "react";
import DocumentContext from '../../contexts/document';
import Header from '../../components/Header';

import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import { exportPdf } from '../../processes/document';
import { getCode } from '../../utils/utils';

import Container from '../../components/Container';
import SignatureSuccess from "./SignatureSuccess";
import SignatureSuccessDesktop from './SignatureSucessDesktop/SignatureSuccessDesktop';

import { useWindowDimensions } from "../../utils/windowDimensionSize";
import { usePatientDocumentContext } from "../../contexts/PatientDocument";

function SignatureSucessContainer() {
	const history = useHistory();

	const { document, code, signedCode } = usePatientDocumentContext(DocumentContext);
	const [loading, setLoading] = useState(false);

	const urlCode = getCode();
	const isSignatureConfirmed = !!document && !!signedCode && signedCode === code && signedCode === urlCode;

	useEffect(() => {
		if (isSignatureConfirmed) {
			return;
		}

		return history.replace(`/?code=${urlCode || code || ''}`);
	}, [isSignatureConfirmed, urlCode, code, history]);


	const handleExportPdf = useCallback(async () => {
		if (document?.pdf_url) {
			window.open(document?.pdf_url, '_blank');
			return;
		}

		setLoading(true);

		const filter = {
			id: document?.id,
			code
		};

		const { data, error } = await exportPdf(filter);

		setLoading(false);

		if (error) {
			toast.error('Não foi possível baixar o documento.')
		} else {
			window.open(data.url, '_blank');
		}
	}, [code, document?.id, document?.pdf_url]);

	const documentTextMarkup = useCallback(() => {
		return {
			__html: document?.text
		};
	}, [document?.text])

	const { width } = useWindowDimensions();

	return (
		<Container>
			{ width >= 600 ? (
				<>
					<Header />

					<SignatureSuccessDesktop
						document={isSignatureConfirmed ? document : null}
						documentTextMarkup={documentTextMarkup}
						exportPdf={handleExportPdf}
						loading={loading}
					/>
				</>
				) : (
					<SignatureSuccess
						document={isSignatureConfirmed ? document : null}
						exportPdf={handleExportPdf}
						loading={loading}
					/>
				)
			}
		</Container>
	)
}

export default SignatureSucessContainer;
